import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2 py-0.5 font-mono text-xs font-semibold uppercase tracking-widest transition-colors",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground",
        secondary:
          "border-border bg-secondary text-secondary-foreground",
        destructive:
          "border-transparent bg-destructive/15 text-destructive",
        warning:
          "border-amber-500/20 bg-amber-500/10 text-amber-500",
        outline:
          "border-border text-foreground bg-transparent",
        success:
          "border-emerald-500/20 bg-emerald-500/10 text-emerald-500",
        high:
          "border-red-500/20 bg-red-500/10 text-red-400",
        medium:
          "border-amber-500/20 bg-amber-500/10 text-amber-400",
        low:
          "border-zinc-500/20 bg-zinc-500/10 text-zinc-400",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
